import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import Popup from "reactjs-popup";
import {
  Button,
  IconButton,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
} from "@material-tailwind/react";
import { HiArrowDownCircle } from "react-icons/hi2";
import { MdDeleteOutline } from "react-icons/md";

import { colorsConfig } from "../../config/colorsConfig";
import { useConversationContext } from "../../contexts/ConversationContextProvider";
import { useUserContext } from "../../contexts/UserContextProvider";
import { Loader, SeoTags } from "..";
import { isoTimestampToLocalWithFormat } from "../utils/timeStampConversion";

const AllChatBots = () => {
  const { isLoading } = useUserContext();
  const navigate = useNavigate();
  const { getUserBots, deleteChatbot } = useConversationContext();
  const [userChatbot, setUserChatbot] = useState([]);

  const botTableColumns = [
    {
      name: "Bot ID",
      selector: (row) => row?._id,
      sortable: true,
      maxWidth: "300px",
    },
    {
      name: "Created Date",
      selector: (row) =>
        isoTimestampToLocalWithFormat(row?.creationDate * 1000),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      maxWidth: "200px",
      selector: (row) => {
        return (
          <div className="flex gap-3 w-96">
            <Menu>
              <MenuHandler>
                <IconButton variant="text">
                  <HiArrowDownCircle className="h-7 w-7" />
                </IconButton>
              </MenuHandler>
              <MenuList>
                <MenuItem>
                  <Popup
                    trigger={
                      <Button color="red" className="w-36">
                        Delete Chatbot
                      </Button>
                    }
                    position="left bottom"
                    className="hidden"
                  >
                    <div className="my-popup-style-1">
                      <p>Are you sure you want to delete "</p>
                      <button
                        type="button"
                        onClick={() => handleDeleteOnClick(row?._id)}
                        className="my-button-style-cancel mt-2 flex items-center gap-1 text-sm"
                      >
                        <MdDeleteOutline size="0.8rem" />
                        Delete Chatbot
                      </button>
                    </div>
                  </Popup>
                </MenuItem>
                <MenuItem>
                  <Button
                    type="button"
                    color="green"
                    onClick={() => {
                      navigate(`/dashboard/flow-chatbot/${row?._id}`);
                    }}
                    className="w-36"
                  >
                    Edit Chatbot
                  </Button>
                </MenuItem>
              </MenuList>
            </Menu>
          </div>
        );
      },
      grow: 0,
    },
  ];

  const fetchChatbotsData = async () => {
    const response = await getUserBots();
    setUserChatbot(response);
  };

  const handleDeleteOnClick = async (botId) => {
    await deleteChatbot(botId);
    await fetchChatbotsData();
  };

  useEffect(() => {
    fetchChatbotsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="w-full mt-5 mb-10 lg:my-1 space-y-5">
      <SeoTags title="Chatbots ‣ WaBM" />

      <div className="w-full space-y-2">
        <h1 className="text-2xl">Manage your Chatbots</h1>
        <h3>
          Create, edit, enable or disable your customized flow based Chatbots
        </h3>
      </div>

      <div className="wbm-card-3 space-y-3">
        <h2 className="font-Montserrat text-lg">All Flow Chatbots</h2>

        <Button
          type="button"
          variant="gradient"
          color="blue"
          onClick={() => {
            navigate(`/dashboard/flow-chatbot/${" "}`);
          }}
        >
          Create a New Flow Chatbot
        </Button>
        <div className="rounded-md overflow-auto">
          {isLoading ? (
            <Loader />
          ) : userChatbot?.length > 0 ? (
            <DataTable
              columns={botTableColumns}
              data={userChatbot}
              customStyles={botTableStyles}
              fixedHeader
              fixedHeaderScrollHeight="60vh"
            />
          ) : (
            <div className="space-y-3">
              <p>No Active Flow Chatbot</p>
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default AllChatBots;

const botTableStyles = {
  rows: {
    style: {},
  },
  headCells: {
    style: {
      backgroundColor: colorsConfig.mediumGrey,
      color: "#FFFFFF",
      fontSize: "0.9rem",
    },
  },
  cells: {
    style: {},
  },
};
